import { useRef } from 'react'
import ThemeIcon from '../../../assets/icons/themeIcon.svg?react'
import LanguageIcon from '../../../assets/icons/languageIcon.svg?react'
import { ThemeDropdown } from '../themeDropdown'
import { LanguageDropdown } from '../languageDropdown'
import { useLocalization, LocalizationKeys } from '../../../i18n'
import { useToggle } from '../../../hooks/useToggle'
import { useCloseOnInteractions } from '../../../hooks/useCloseOnInteractions'
import styles from './bottomActions.module.css'

export function BottomActions() {
  const { t } = useLocalization()
  
  const themeButtonRef = useRef<HTMLButtonElement>(null)
  const languageButtonRef = useRef<HTMLButtonElement>(null)
  
  const themeDropdown = useToggle(false)
  const languageDropdown = useToggle(false)
  
  const themeWrapperRef = useCloseOnInteractions<HTMLDivElement>({
    isActive: themeDropdown.isOpen,
    onClose: themeDropdown.close,
    shouldIgnoreEvent: (event) => {
      // Ignore clicks inside the theme dropdown (rendered via portal)
      const target = event.target as HTMLElement
      return target.closest('[role="menu"]') !== null
    },
  })
  
  const languageWrapperRef = useCloseOnInteractions<HTMLDivElement>({
    isActive: languageDropdown.isOpen,
    onClose: languageDropdown.close,
    shouldIgnoreEvent: (event) => {
      // Ignore clicks inside the language dropdown (rendered via portal)
      const target = event.target as HTMLElement
      return target.closest('[role="menu"]') !== null
    },
  })

  const handleThemeClick = () => {
    if (languageDropdown.isOpen) languageDropdown.close()
    themeDropdown.toggle()
  }

  const handleLanguageClick = () => {
    if (themeDropdown.isOpen) themeDropdown.close()
    languageDropdown.toggle()
  }

  return (
    <div className={styles.bottomActions}>
      <div 
        className={styles.actionWrapper}
        ref={themeWrapperRef}
        data-open={themeDropdown.isOpen}
      >
        <button
          ref={themeButtonRef}
          type="button"
          className={styles.actionButton}
          onClick={handleThemeClick}
          aria-label={t(LocalizationKeys.PROFILE_THEME)}
          title={t(LocalizationKeys.PROFILE_THEME)}
          aria-haspopup="menu"
        >
          <ThemeIcon className={styles.icon} />
        </button>
        {themeDropdown.isOpen && <ThemeDropdown onClose={themeDropdown.close} buttonRef={themeButtonRef} />}
      </div>

      <div 
        className={styles.actionWrapper}
        ref={languageWrapperRef}
        data-open={languageDropdown.isOpen}
      >
        <button
          ref={languageButtonRef}
          type="button"
          className={styles.actionButton}
          onClick={handleLanguageClick}
          aria-label={t(LocalizationKeys.PROFILE_LANGUAGE)}
          title={t(LocalizationKeys.PROFILE_LANGUAGE)}
          aria-haspopup="menu"
        >
          <LanguageIcon className={styles.icon} />
        </button>
        {languageDropdown.isOpen && <LanguageDropdown onClose={languageDropdown.close} buttonRef={languageButtonRef} />}
      </div>
    </div>
  )
}
